function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 105.792,
  y: 260.194,
  width: 15.938,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 137.664,
  y: 260.194,
  width: 15.937,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 169.546,
  y: 260.194,
  width: 15.937,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 201.418,
  y: 260.194,
  width: 15.937,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 233.29,
  y: 260.194,
  width: 15.937,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 265.173,
  y: 260.194,
  width: 15.938,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 297.045,
  y: 260.194,
  width: 15.937,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 328.917,
  y: 260.194,
  width: 15.937,
  height: 15.527
}), /*#__PURE__*/React.createElement("rect", {
  x: 360.8,
  y: 260.194,
  width: 15.937,
  height: 15.527
}), /*#__PURE__*/React.createElement("polygon", {
  points: "233.089,116.339 249.232,116.339 249.232,100.812 233.089,100.812 233.089,84.464 249.232,84.464  249.232,68.936 233.089,68.936 233.089,36.65 251.448,36.65 305.556,214.431 320.409,209.911 262.951,21.123 217.561,21.123  217.561,212.171 233.089,212.171  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.716,268.299l-36.368-36.368c-7.472-7.472-17.406-11.586-27.972-11.586H102.282l-17.913-30.707l0.083,0.016 l14.704-80.873H60.017l-7.269,26.652l-6.25-10.714H2.401v138.7l11.213,10.193L0,323.53h39.508l7.209-19.824l48.103,43.731h122.74 v143.44h45.391l43.656-143.44h169.379c19.858,0,36.014-16.156,36.014-36.013v-3.626C512,287.07,496.01,270.008,475.716,268.299z  M71.877,124.307h8.674l-8.149,44.817l-8.687-14.893L71.877,124.307z M28.633,308.003h-8.304l19.672-72.131h14.862 L28.633,308.003z M100.823,331.91l-9.218-8.38H217.56v8.38H100.823z M305.556,297.569l-54.108,177.782h-18.359v-32.286h16.143 v-15.527h-16.143v-16.348h16.143v-15.527h-16.143V291.86h-15.527v16.143H74.526l-22.074-20.067l24.58-67.591h-48.89L18.2,256.797 l-0.271-0.247V140.245h19.652l55.783,95.627h318.013c6.419,0,12.454,2.5,16.993,7.039l17.279,17.279h-29.071v15.527h44.598 l0.782,0.781l-25.204,31.505H318.609l1.8-5.914L305.556,297.569z M475.986,331.91H311.333l2.551-8.38h130.332l31.667-39.585 c11.632,1.71,20.589,11.753,20.589,23.852v3.627h0.001C496.473,322.72,487.283,331.91,475.986,331.91z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgAirplane = function SvgAirplane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAirplane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/airplane.4955dc9a.svg";
export { ForwardRef as ReactComponent };